import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ConsultationSection from '../consultation/consultationSection';
import LabTestSection from '../Lab/labTestSection';
import PrescriptionSection from '../Prescriptions/PrescriptionSection';
import { ConsultationProvider, useConsultation } from '../../../ReduxSlices/Consultations/consultationProvider';
import { clearSelectedPatient } from '../../../ReduxSlices/Patients/patientSlice';

const PatientDetailsInner = ({ patient, currentUserId, activeTab, role,  patientQueueId }) => {
  const { consultations = [] } = useConsultation();
  const latestConsultation = consultations[0]; 

  //console.log('PatientDetailsInner received patientQueueId:', patientQueueId);

  return (
    <>
      {activeTab === 'info' && (
        <div className="space-y-2">
          <h3>Patient Details</h3>
          <div className="details">
            <p><strong>Name:</strong> {patient.name}</p>
            <p><strong>Age:</strong> {patient.age || 'N/A'}</p>
            <p><strong>Contact Info:</strong> {patient.contact_info || 'N/A'}</p>
          </div>
        </div>
      )}

      {role === 'doctor' && (
        <>
          {activeTab === 'consultations' && (
            <ConsultationSection patientId={patient.id} currentUserId={currentUserId} />
          )}

          {activeTab === 'labtests' && (
            <LabTestSection
              patientId={patient.id}
              currentUserId={currentUserId}
              consultationId={latestConsultation?.id}
              patientQueueId={patientQueueId} 
              role={role} 
            />
          )}

          {activeTab === 'prescriptions' && (
            <PrescriptionSection 
            patientId={patient.id} 
            currentUserId={currentUserId} 
            patientQueueId={patientQueueId} 
            consultationId={latestConsultation?.id} />
          )}
        </>
      )}
    </>
  );
};

const PatientDetails = ({ patient, role }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('info');
  const [currentUserId, setCurrentUserId] = useState(null);

    // Log the patient object and queue id
  //console.log('PatientDetails received patient:', patient);
  //console.log('PatientDetails patientQueueId:', patient.patientQueueId);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUserId(storedUser?.id);
  }, []);

  if (!patient) return <p className="p-4">Patient not found.</p>;

  // Tabs vary by role
  const tabs = role === 'doctor'
    ? ['info', 'consultations', 'labtests', 'prescriptions']
    : ['info'];

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => dispatch(clearSelectedPatient())}
          type="button"
          className="btn-arrow px-4 py-2 bg-blue-500 text-white rounded"
        >
          <img src="/backarrow.svg" alt="back-arrow" className="arrow" />
        </button>

    {tabs.length > 1 && (   
      <div className="flex space-x-2 gap-[2px]">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={`px-3 py-1 rounded ${
              activeTab === tab ? 'primary tabs' : 'secondary bg-gray-200 '
            }`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>
      )}
    </div>

      <ConsultationProvider patientId={patient.id}>
        <PatientDetailsInner
          patient={patient}
          currentUserId={currentUserId}
          activeTab={activeTab}
          role={role}
         patientQueueId={patient.patientQueueId}
        />
      </ConsultationProvider>
    </div>
  );
};

PatientDetails.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    age: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    contact_info: PropTypes.string,
  }).isRequired,
  role: PropTypes.oneOf(['receptionist', 'doctor']).isRequired,
};

export default PatientDetails;
